import logo from "../../logo.svg";
import { useEffect } from "react";
export default function TelaAgradecimento() {
  const handleLocalStorage = () => {
    localStorage.setItem("local", null);
  };

  useEffect(() => {
    handleLocalStorage();
  }, []);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        justifyItems: "center",
        flexDirection: "column",
        minHeight: "100%",
        minWidth: "100%",
      }}
    >
      <h1
        style={{
          margin: "198px 2px 2px 2px",
          textAlign: "center",
        }}
      >
        Agradecemos por sua participação!
      </h1>
      <img
        src={logo}
        style={{
          padding: "55px",
        }}
        alt="logo"
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>
  );
}
